export const clientOptions = [
  { _id: "I'm a buyer", value: "I'm a buyer" },
  { _id: "I'm a tenant", value: "I'm a tenant" },
  { _id: "I'm an agent", value: "I'm an agent" },
  { _id: 'other', value: 'other' },
];
